// extracted by mini-css-extract-plugin
export default {"button":"button_button__4-vvU","primary":"button_primary__BK63+","secondary":"button_secondary__bhiuF","large":"button_large__T7Vhv"};